(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["share-social"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var shareSocials = document.querySelectorAll('[data-share-social]');

    shareSocials.forEach(function (container) {
      var button = container.querySelector('[data-share-button]');
      var copyBtn = container.querySelector('[data-copy-link]');

      if (button) {
        button.addEventListener('click', function (e) {
          e.stopPropagation();
          container.classList.add('is-open');
        });
      }

      document.addEventListener('click', function (e) {
        if (!container.contains(e.target)) {
          container.classList.remove('is-open');
        }
      });

      if (copyBtn) {
        copyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var link = copyBtn.getAttribute('data-copy-link');
          if (link) {
            navigator.clipboard.writeText(link).catch(function () {});
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
